import { render } from "./SlideDrei.vue?vue&type=template&id=99de8588"
import script from "./SlideDrei.vue?vue&type=script&lang=js"
export * from "./SlideDrei.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bene\\Development\\machina_eX\\LayersOfLife\\bundesanstalt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__